import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CasesService } from "../../cases.service";
import { Reminders } from "../../case";
import { StorageService } from "app/main/module/common/service/storage.service";
import * as moment from "moment";
import { MatSnackBar } from "@angular/material/snack-bar";
const timeZone = require("moment-timezone");

@Component({
    selector: "app-view-reminder-details",
    templateUrl: "./view-reminder-details.component.html",
    styleUrls: ["./view-reminder-details.component.scss"],
})
export class ViewReminderDetailsComponent implements OnInit {
    reminderData: Reminders[] = [];
    isLoading: Boolean = false;
    hasFirstDataShown: Boolean = false;

    constructor(
        private router: Router,
        public caseService: CasesService,
        private route: ActivatedRoute,
        private userService: StorageService,
        public snackbar : MatSnackBar
    ) {}

    ngOnInit(): void {
        const id = this.route.snapshot.queryParamMap.get("reminder_id");
        this.getSingleReminder(id);
    }

    getSingleReminder(id) {
        this.isLoading = true;
        this.caseService.getSingleViewReminder(id).subscribe(
            (res: any) => {
                if (res && res.data) {
                    this.reminderData = res.data;
                    // console.log(this.reminderData);

                    this.hasFirstDataShown = true;
                    this.isLoading = false;
                } else {
                    this.reminderData = [];
                }
            },
            (error) => {
                console.error("Error fetching cases:", error);
            }
        );
    }

    back() {
        this.router.navigate(["/cases/view-reminder"]);
    }

    updateDate(value: string): string {
        if (!value || value.trim() === "") return "-";

        const tz = moment.tz.zone(this.userService.getCookie("defaultTz"))
            ? this.userService.getCookie("defaultTz")
            : "UTC";

        let m = moment(value);
        if (!m.isValid() && /^\d+$/.test(value)) {
            m = moment(Number(value));
        }

        return m.isValid() ? m.tz(tz).format("DD-MM-YYYY | HH:mm") : "-";
    }
    openSnackBar(message: string, action: string): void {
        // this.isLoading = true;
        // this.hasFirstDataShown = true;
        this.snackbar.open(message, action, {
            duration: 1000,
        });
    }
}
